import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import { IInfrastructureCell } from '../../../../../../types/newbuildingsCompare';

export interface IInfrastructureCellProps {
  cell: IInfrastructureCell;
}

export const InfrastructureCell = ({ cell }: IInfrastructureCellProps): React.JSX.Element => (
  <Body2>{cell.data?.infrastructures.map(item => item.text).join(', ') ?? cell.state.text ?? ''}</Body2>
);
